module.exports = __webpack_public_path__ + "img/plexus-5-small.b7e14bee.png";